import reviewWidget from "./components/reviewWidget.vue";
import reviewWidgetSmall from "./components/reviewWidgetSmall.vue";

export function createApp() {
    Vue.component( "review-widget", reviewWidget );
    Vue.component( "review-widget-small", reviewWidgetSmall );
}
